import { useEffect, useState } from "react";
import FullScreenModal from "../../../components/FullScreenModal";
import { PostCard } from "./components/PostCard";
import { TABS, UserDetailsTabs, UserTabs } from "./components/Tabs";
import { Tabs } from "../UserTabs";
import { Banner } from "./components/Banner";
import { StylistCard } from "./components/StylistCard";
import { Posts } from "./components/Posts";
import { api } from "../../../helpers/api";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { ShowToast } from "../../../components/toast";
import { ConfirmDeletePost } from "./components/ConfirmDeletePost";
import { Services } from "./components/Services";
import { LikedPosts } from "./components/LikedPosts";
import { Reviews } from "./components/Reviews";
import { ConfirmBlock, ConfirmDelete } from "../UserDetails";
import { ReviewModal } from "./components/ReviewModal";
import { ChangeTypeForm } from "./components/ChangeTypeForm";

export function UserDetails({ isOpen, onClose, type, user, refresh }) {
  const queryClient = useQueryClient();
  const [updateUserModal, setUpdateUserModal] = useState(false);
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [selectedTab, setSelectedTab] = useState(UserTabs.Posts);
  const [deletePostConfirmation, setDeletePostConfirmation] =
    useState<any>(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<any>(false);
  const [isBlockModalOpen, setIsBlockModalOpen] = useState<any>(false);
  const [isDeletingPost, setIsDeletingPost] = useState(false);
  const handleDelete = () => {
    setIsDeletingPost(true);
    api
      .deletePost(deletePostConfirmation?.id)
      .then(() => {
        ShowToast({
          message: "Post deleted successfully",
          type: "success",
        });
        refresh();
        setDeletePostConfirmation(false);
        queryClient.invalidateQueries({ queryKey: ["posts"] });

        setIsDeletingPost(false);
      })
      .catch(() => {
        ShowToast({
          message: "Failed to delete post",
          type: "error",
        });
        setIsDeletingPost(false);
      });
  };
  const { data: userDetailsData, isLoading } = useQuery({
    queryKey: ["chart", user?.id],
    queryFn: () =>
      api.getUser({
        id: user.id,
      }),
    enabled: !!user,
  });
  const { data: likedData } = useQuery({
    queryKey: ["liked-posts", user?.id],
    queryFn: () =>
      api.getLikedPosts({
        userId: user?.id,
        page: 1,
        limit: 10,
      }),
    enabled: !!user,
  });
  const { data: savedData } = useQuery({
    queryKey: ["saved-posts", user?.id],
    queryFn: () =>
      api.getSavedPosts({
        userId: user?.id,
        page: 1,
        limit: 10,
      }),
    enabled: !!user,
  });

  const { data: stylistData, isLoading: stylistLoading } = useQuery({
    queryKey: ["stylists", user?.id],
    queryFn: () => api.getStylists(user.id),
    enabled: !!user,
  });

  useEffect(() => {
    if (isOpen) {
      setSelectedTab(TABS.POSTS);
    }
  }, [isOpen]);

  const details = userDetailsData?.data;
  console.log(userDetailsData, "userDetailsData", user, likedData, savedData);
  return (
    <>
      <>
        <FullScreenModal isOpen={isOpen} onClose={onClose}>
          <div className="max-w-[898px] mx-auto mt-[34px]">
            <Banner
              userType={type}
              details={details}
              onDeactivate={() => setIsBlockModalOpen(true)}
              onDelete={() => setIsDeleteModalOpen(true)}
              user={user}
              onReview={() => setShowReviewModal(true)}
              onUpdate={() => setUpdateUserModal(true)}
            />
            <UserDetailsTabs
              type={type}
              selectedTab={selectedTab}
              setSelectedTab={setSelectedTab}
              values={{
                Posts: user?.totalPosts,
                Liked: likedData?.total,
                Saved: savedData?.total,
                Stylists: stylistData?.length,
              }}
            />
            {/* <div className="mt-5 flex mx-7 px-3 pb-3 gap-4 tall:max-h-[575px] max-h-[600px] overflow-auto flex-wrap"> */}
            {selectedTab === TABS.POSTS && (
              <>
                <Posts
                  type={TABS.POSTS}
                  user={user}
                  refresh={refresh}
                  postDeleteLoading={isDeletingPost}
                  onPostDelete={(post) => {
                    setDeletePostConfirmation(post);
                  }}
                />
              </>
            )}
            {selectedTab === TABS.LIKED && (
              <>
                <LikedPosts user={user} refresh={refresh} type={TABS.LIKED} />
              </>
            )}
            {selectedTab === TABS.SAVED && (
              <>
                <LikedPosts user={user} refresh={refresh} type={TABS.SAVED} />
              </>
            )}
            {selectedTab === TABS.REVIEWS && (
              <>
                <Reviews user={user} refresh={refresh} />
              </>
            )}
            {selectedTab === TABS.STYLISTS && (
              <div className="flex flex-wrap gap-4 mx-10 mt-4 pb-4 tall:max-h-[575px] max-h-[400px] overflow-auto">
                {stylistData?.map((stylist, index) => (
                  <StylistCard key={stylist.id} stylist={stylist} />
                ))}
              </div>
            )}
            {selectedTab === TABS.SERVICES && <Services data={details} />}
          </div>
        </FullScreenModal>

        {updateUserModal && (
          <ChangeTypeForm
            user={user}
            onUpdate={() => refresh()}
            onClose={() => {
              setUpdateUserModal(false);
              onClose();
            }}
          />
        )}

        {deletePostConfirmation.id && (
          <ConfirmDeletePost
            onClose={() => setDeletePostConfirmation(false)}
            refetch={refresh}
            postId={deletePostConfirmation.id}
            onDelete={() => handleDelete()}
            isLoading={isDeletingPost}
          />
        )}

        {isDeleteModalOpen && (
          <ConfirmDelete
            userId={user?.id || ""}
            refetch={() => {
              queryClient.invalidateQueries({ queryKey: ["users"] });
              queryClient.invalidateQueries({
                queryKey: ["chart", user?.id],
              });
              refresh();
              onClose();
            }}
            onClose={() => setIsDeleteModalOpen(false)}
            name={user?.fullName}
          />
        )}
        {isBlockModalOpen && (
          <ConfirmBlock
            userId={user?.id || ""}
            refetch={() => {
              queryClient.invalidateQueries({ queryKey: ["users"] });
              queryClient.invalidateQueries({
                queryKey: ["chart", user?.id],
              });
              refresh();
              onClose();
            }}
            onClose={() => setIsBlockModalOpen(false)}
            name={user?.fullName}
          />
        )}
        {showReviewModal && (
          <ReviewModal
            onClose={() => setShowReviewModal(false)}
            isOpen={showReviewModal}
            type={type}
            user={user}
            refresh={refresh}
          />
        )}
      </>
    </>
  );
}
